import { render, staticRenderFns } from "./OurSavedSearchesMenu.vue?vue&type=template&id=c9907488&"
import script from "./OurSavedSearchesMenu.vue?vue&type=script&lang=js&"
export * from "./OurSavedSearchesMenu.vue?vue&type=script&lang=js&"
import style0 from "./OurSavedSearchesMenu.vue?vue&type=style&index=0&id=c9907488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports